module.exports = __webpack_public_path__ + "img/platillo_beerfactory.85509352.webp";